import {isEqual} from 'lodash-es';
import {getPlatformURL} from '@stripe-internal/connect-embedded-lib';
import {analytics} from './analytics';
import {
  getFirstLoadedFont,
  isFontLoaded,
} from '../utils/dom/getLoadedFontFamilies';
import type {
  IFrameLogIframeLoadedFontRequest,
  IFrameLogIframeLoadedFontResponse,
} from '../data-layer-client/FrameMessenger';

const platformUrl = getPlatformURL();
const platformHostName = platformUrl ? new URL(platformUrl).hostname : '';

let lastMessage = {
  platformLoadedFont: '',
  iframeLoadedFont: '',
  availableInIframe: false,
  platformHostName: '',
};

export const logFontFamily = ({
  id,
  type,
  request: {platformLoadedFont, fontFamily},
}: IFrameLogIframeLoadedFontRequest): IFrameLogIframeLoadedFontResponse => {
  const iframeLoadedFont = fontFamily && getFirstLoadedFont(fontFamily);
  const availableInIframe =
    !!platformLoadedFont && isFontLoaded(platformLoadedFont);
  const message = {
    platformLoadedFont,
    iframeLoadedFont,
    availableInIframe,
    platformHostName,
  };

  if (
    platformLoadedFont &&
    iframeLoadedFont &&
    !isEqual(message, lastMessage)
  ) {
    analytics.track('connect_js_font_loaded', message);
    lastMessage = message;
  }

  return {
    id,
    type,
    requestType: 'logIframeLoadedFontResponse',
    response: message,
  };
};
